/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>azure-ad-auth-login.component.ts</name>
///
/// <description>
/// A class that handles the authenticated user's login
/// </description>
///
/// <author>Yaron Habot</author>
/// <created>12 Aug 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 12Aug16 YH  1.0.0000         First cut
/// 21Mar17 YH                   Bug 124419 - [NAV]Login Allowed for a Particular Account User(Account is logged out) through URL
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import {Component} from '@angular/core';
import { HydrogenAppConfigService } from '../../../host.config.service'
import {hydUtilService} from "../../../utils/hydUtils.service";
//YH 3/21/2017 Bug 124419
import { HydUser } from '../../../models/user';

@Component({
    selector: 'azure-ad-auth-login',
    template: '<button pButton label="Sign In" type="button" (click)="Login($event)"></button>',
})


export class AzureADAuthLoginComponent {
    constructor(
        private configSvc: HydrogenAppConfigService,
        private hydUser: HydUser
    ) {
        console.log('hydAzureADLoginComponent constructor '+window.location);
    }

    Login(event) {
        event.preventDefault();
        
        //YH 3/21/2017 Bug 124419
        //Prevent authentication code replay by storing the nonce and verify on auth reply that it is the same nonce as the login 
        let state = this.createNonce();        
        this.hydUser.setAuthenticationCodeState(state);

        if(!this.configSvc.config.UseB2C) {
            let endpoint =
                this.configSvc.config.azureAD.SecureTokenServer + this.configSvc.config.azureAD.Tenant + this.configSvc.config.azureAD.OAuth2url +
                "?response_type=code" +
                "&response_mode=query" +
                "&client_id=" + this.configSvc.config.azureAD.AADHydrogenClientId +
                "&redirect_uri=" + this.GetRedirectUrl() +
                "&scope=openid" +
                "&state=" + state +
                "&nonce=" + this.createNonce()
                ;
            console.debug(hydUtilService.TimeStamp()+"Redirecting to Azure AD url:"+endpoint);
            window.location.href = endpoint;
        } else {
            var scopePrefix = "XiO";
            var policyName = "B2C_1A_QE_signup_signin"
            if(this.configSvc.config.azureB2C.ScopePrefix) {
                scopePrefix = this.configSvc.config.azureB2C.ScopePrefix;
            }
            if(this.configSvc.config.azureB2C.PolicyName) {
                policyName = this.configSvc.config.azureB2C.PolicyName;
            }

            let endpoint =
            this.configSvc.config.azureB2C.SecureTokenServer + this.configSvc.config.azureB2C.Tenant + this.configSvc.config.azureB2C.OAuth2url +
            "?response_type=code" +
            "&response_mode=query" +
            "&client_id=" + this.configSvc.config.azureB2C.AADHydrogenClientId +                            
            "&redirect_uri=" + this.GetRedirectUrl() +                                        
            "&scope=https://" + this.configSvc.config.azureB2C.Tenant + "/"+ scopePrefix + "/read openid offline_access" + 
            "&state=" + state +
            "&nonce=" + this.createNonce() +
            "&domain_hint=XiO_AAD" +
            "&p=" + policyName;
            
            console.debug(hydUtilService.TimeStamp()+"Redirecting to Azure AD url:"+endpoint);
            window.location.href = endpoint;
        }
    }

    GetRedirectUrl() {
        let url: string = window.location.protocol + "//" + window.location.host + this.configSvc.config.azureAD.LoginReplyPath;                 
        return url;
    }

    createNonce() {
        let nonce = "";
        let chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (let i = 0; i < 32; i++) {
            nonce += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return nonce;
    }

}


// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/authentication/azure-active-directory/azure-ad-auth-login/azure-ad-auth-login.component.ts